import { render, staticRenderFns } from "./DictSelect.vue?vue&type=template&id=10e67fda&"
import script from "./DictSelect.vue?vue&type=script&lang=js&"
export * from "./DictSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports